module.exports = __webpack_public_path__ + "static/img/12.b49411d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/12.png
// module id = q9H3
// module chunks = 0